module.exports = __webpack_public_path__ + "media/images/icon__delete--rb-orange@2x-77e1730ce93b73946ab23166d445214a.png";